import "core-js/modules/es.number.constructor.js";
import _debounce from 'lodash/debounce';
import { renderMarkdownInline } from '~/functions/markdown';
export default defineComponent({
  inheritAttrs: false,
  props: {
    value: {
      type: [Array, String, Number],
      default: function _default() {
        return [];
      }
    },
    isEditable: {
      type: Boolean,
      default: false
    },
    isMultiple: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    allowDeselection: {
      type: Boolean,
      default: true
    },
    isCompact: {
      type: Boolean,
      default: false
    }
  },
  setup: function setup(_, _ref) {
    var emit = _ref.emit;
    var updateValue = _debounce(function (value) {
      emitUpdate(value);
    }, 400);
    var emitUpdate = function emitUpdate(value) {
      emit('input', value);
      emit('update:value', value);
    };
    onBeforeUnmount(function () {
      updateValue.flush();
    });
    return {
      updateValue: updateValue,
      renderMarkdownInline: renderMarkdownInline
    };
  }
});